import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { select, Store } from "@ngrx/store";
import * as fsProfileActions from "./../../store/action/fs.action";

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss']
})
export class ImpersonateComponent implements OnInit {

  	constructor(public http: HttpClient, private router: Router, private activatedRoute: ActivatedRoute, public store: Store<any>,) { }

  	ngOnInit() {
  		this.activatedRoute.params.subscribe((params: Params) => {
  			console.log(params);
	      	localStorage.setItem('id_token', params['id']);
	      	const expiresAt = JSON.stringify((7200 * 1000) + new Date().getTime());
        	localStorage.setItem('expires_at', expiresAt);
	      	localStorage.setItem('impersonation', 'true');
          this.storeActions();
          this.router.navigate(['/dashboard']);
            // this.http.get(`${environment.profileURL}/api/v1/users/find_by_token`).subscribe(data => {
            //   console.log(data);
            //   localStorage.setItem('auth_id', data['uid']);
            //   this.router.navigate(['/dashboard']);
            // },
            //     error => console.log('oops', error)
            // )
	      	
	    });
  	}

    public storeActions() {
        // profile action
        this.store.dispatch(fsProfileActions.getProfile());
        // access group action
        this.store.dispatch(fsProfileActions.getAccessGroup());
    }

}
